export default __webpack_public_path__ + "static/media/Nunito-Bold.aa521eff.svg";